import React, { FC } from 'react';
import styled from 'styled-components';
import ICtaIconBox from '../../../interfaces/elements/ctaIconBox';
import { Column, Columns } from '../../base/grid';
import { H3 } from '../../base/typography';
import CtaIconBox from '../ctaIconBox/ctaIconBox';

const StyledWrapper = styled.div``;

interface Props {
	title?: string;
	boxes: ICtaIconBox[];
}

const CtaIconBoxColumns: FC<Props> = ({ title, boxes }) => {
	return (
		<StyledWrapper>
			{title && title.length > 0 && <H3 marginBottom="6rem">{title}</H3>}
			<Columns>
				{boxes.map((box, index) => (
					<Column tablet={1 / 3} key={index}>
						<CtaIconBox box={box} />
					</Column>
				))}
			</Columns>
		</StyledWrapper>
	);
};

export default CtaIconBoxColumns;
